/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Modal } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";

import './EscapeStats.css';


class EscapeStats extends Component {

  render() {
    let escapes = this.props.escapes || [];
    if (!escapes) return null;

    let count = 0;
    let total = escapes.length;
    for (let escape of escapes) {
      if (escape.didEscape) {
        count++;
      }
    }
    let percent = 0;
    if (total) {
      percent = Math.round(100 * count / total);
    }

    let sortedEscapes = escapes.sort((a, b) => { return b.id - a.id });

    let cities = {};
    let countries = {};

    let current = 0;
    let activeStreak = 0;
    let longestStreak = 0;
    let streakBroke = false;
    for (let escape of sortedEscapes) {
      if (escape.room.location && escape.room.location.city) {
        let city = escape.room.location.city;
        cities[city.id] = city.name;
        countries[city.country] = city.countryName;
      }

      if (escape.didEscape) {
        current++;
      } else {
        current = 0;
        streakBroke = true;
      }

      if (!streakBroke) {
        activeStreak = Math.max(activeStreak, current);
      }
      longestStreak = Math.max(longestStreak, current);
    }
    let escapeSummary = null;

    let cityCount = Object.keys(cities).length;
    let countryCount = Object.keys(countries).length;

    if (total) {
      escapeSummary = (
        <div className="escape-summary">
          <div className="escape-stats">
            <div>Escape <b>RATE</b>: <b>{percent}%</b></div>
            <div>Rooms <b>ATTEMPTED</b>: <b>{total}</b></div>
            <div>Rooms <b>ESCAPED</b>: <b>{count}</b></div>
            <div>Cities: <b>{cityCount}</b></div>
            <div>Countries: <b>{countryCount}</b></div>
            <div>Your <b>CURRENT STREAK</b> of escapes: <b>{activeStreak}</b></div>
          </div>
        </div>
      );
    }

    if (true) {
      escapeSummary = (
        <div className="escape-summary">
          <div className="summary-title">{this.props.title}</div>

          <div className="escape-stats">
            <div className="escape-stat">
              <div className="escape-stat-value">{total}</div>
              <div className="escape-stat-label">rooms</div>
            </div>

            <div className="escape-stat">
              <div className="escape-stat-value">{cityCount}</div>
              <div className="escape-stat-label">cities</div>
            </div>

            <div className="escape-stat">
              <div className="escape-stat-value">{countryCount}</div>
              <div className="escape-stat-label">countries</div>
            </div>

            <div className="escape-stat">
              <div className="escape-stat-value">{percent}%</div>
              <div className="escape-stat-label">escape rate</div>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className="EscapeStats">
        {escapeSummary}
      </div>
    );
  }
}
export default EscapeStats;



/** WEBPACK FOOTER **
 ** ./src/components/partials/EscapeStats.js
 **/